"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../../utils/helpers/class-names"));
var accordion_style_1 = require("../accordion.style");
var accordion_details_style_1 = require("./accordion-details.style");
var AccordionDetails = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'outlined' : _b, _c = _a.rounded, rounded = _c === void 0 ? 'medium' : _c, _d = _a.color, color = _d === void 0 ? "primary" : _d, className = _a.className, disabled = _a.disabled, rest = tslib_1.__rest(_a, ["children", "variant", "rounded", "color", "className", "disabled"]);
    var accordionDetailsClassName = (0, class_names_1["default"])('p-2', variant === 'outlined' ? '!bg-white' : accordion_style_1.COLORS[color], accordion_details_style_1.TEXT_COLORS[color], accordion_style_1.ROUNDED[rounded], className);
    if (disabled) {
        return null;
    }
    return (react_1["default"].createElement("div", tslib_1.__assign({ className: accordionDetailsClassName }, rest), children));
};
exports["default"] = AccordionDetails;
//# sourceMappingURL=accordion-details.js.map